import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/ai-requests/{creatorId}/{questionnaireTemplateSlug}/regenerate/{requestId}']['POST'];
type Input = ThisApi['params'];

const regenerateAiRequest = async ({
  creatorId,
  questionnaireTemplateSlug,
  requestId,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/ai-requests/{creatorId}/{questionnaireTemplateSlug}/regenerate/{requestId}', {
    creatorId,
    questionnaireTemplateSlug,
    requestId,
  });
  const data = await formsBackendClient.post(path);
  return data.data;
};

export default regenerateAiRequest;
